import axios from './orderInstance'

export type IncreaseQuantityResponse = unknown

export default async function increaseQuantity(
    orderId: string,
    lineItemId: string,
    quantity: number,
): Promise<IncreaseQuantityResponse> {
    if (!Number.isInteger(quantity) || quantity < 1) {
        throw new Error('Quantity must be a positive integer.')
    }

    const response = await axios.post(
        `/orders/${orderId}/line-items/${lineItemId}/increase-quantity`,
        {quantity},
    )

    return response.data
}
